import { render, staticRenderFns } from "./CrmSearch.vue?vue&type=template&id=9470a9ca&lang=pug"
import script from "./CrmSearch.vue?vue&type=script&lang=js"
export * from "./CrmSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports